export function FamilyMilestonesDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Family Milestone Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Event Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Type of Milestone <span className="text-red-500">*</span>
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select milestone type</option>
              <option value="marriage">Marriage</option>
              <option value="birth">Birth of Children</option>
              <option value="adoption">Adoption</option>
              <option value="anniversary">Anniversary</option>
              <option value="reunion">Family Reunion</option>
            </select>
          </div>

          {/* Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Location <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="City, State/Province, Country"
            />
          </div>

          {/* Venue/Place */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Venue/Place
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter venue or place name"
            />
          </div>

          {/* Family Members Involved */}
          <div className="col-span-2 space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Family Members Involved <span className="text-red-500">*</span>
            </label>
            <textarea
              className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="List key family members involved in this milestone"
            />
          </div>

          {/* Cultural/Religious Significance */}
          <div className="col-span-2 space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Cultural/Religious Significance
            </label>
            <textarea
              className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Describe any cultural or religious significance of this milestone"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 